import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import "./PaymentPassengersFieldset.scss";
import PaymentPassengerFieldset from "./PaymentPassengerFieldset";

const PaymentPassengersFieldset = ({
	isChildrenAgeRequired,
	dateOfBirthRequired,
	showFrequentTravellerCardInput,
}) => {
	const { values } = useFormikContext();

	return (
		<div className="payment-passengers-fieldset">
			{values?.passengers?.length > 0 &&
				values?.passengers?.map(({ birthdate, ...passenger }, index) => {
					const birthDate = new Date(
						birthdate?.year,
						birthdate?.month,
						birthdate?.day,
						15,
						0,
						0
					);

					return (
						<PaymentPassengerFieldset
							key={"passenger-" + index}
							isChildrenAgeRequired={isChildrenAgeRequired}
							dateOfBirthRequired={dateOfBirthRequired}
							showFrequentTravellerCardInput={showFrequentTravellerCardInput}
							passenger={{ ...passenger, birthDate }}
							index={index}
						/>
					);
				})}
		</div>
	);
};

PaymentPassengersFieldset.propTypes = {
	isChildrenAgeRequired: PropTypes.bool,
	dateOfBirthRequired: PropTypes.bool,
	showFrequentTravellerCardInput: PropTypes.bool,
};

export default PaymentPassengersFieldset;
